import { render } from "./AuthForm.vue?vue&type=template&id=3efba8d5&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"

import "./AuthForm.vue?vue&type=style&index=0&id=3efba8d5&scoped=true&lang=scss"

import exportComponent from "Q:\\grdn-auth\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efba8d5"]])

export default __exports__